import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
export function ComparisonTable() {
  const features = [{
    name: 'Diseño profesional',
    landing: true,
    negocio: true,
    plus: true
  }, {
    name: 'Responsive',
    landing: true,
    negocio: true,
    plus: true
  }, {
    name: 'Hosting por 1 año',
    landing: true,
    negocio: true,
    plus: true
  }, {
    name: 'Dominio por 1 año',
    landing: true,
    negocio: true,
    plus: true
  }, {
    name: 'WhatsApp y Contacto',
    landing: true,
    negocio: true,
    plus: true
  }, {
    name: 'Redacción de textos',
    landing: true,
    negocio: true,
    plus: true
  }, {
    name: 'Logotipo y Branding básico',
    landing: true,
    negocio: true,
    plus: true
  }, {
    name: 'SEO básico',
    landing: true,
    negocio: true,
    plus: true
  }, {
    name: 'Secciones del negocio',
    landing: 'Básicas',
    negocio: 'Completas',
    plus: 'Avanzadas'
  }, {
    name: 'Mapa o galería',
    landing: false,
    negocio: true,
    plus: true
  }, {
    name: 'Tienda o catálogo',
    landing: false,
    negocio: false,
    plus: true
  }, {
    name: 'Correos corporativos',
    landing: '1',
    negocio: '2',
    plus: '3'
  }];
  const renderValue = (value: boolean | string) => {
    if (typeof value === 'boolean') {
      return value ? <Check className="text-green-500 mx-auto" size={20} data-id="element-70" /> : <X className="text-red-500 mx-auto" size={20} data-id="element-71" />;
    }
    return <span className="text-nova-text-muted text-sm" data-id="element-72">{value}</span>;
  };
  return <section className="py-32 bg-nova-bg-alt" data-id="element-73">
      <div className="max-w-5xl mx-auto px-6" data-id="element-74">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-75">
          <h2 className="text-3xl md:text-4xl font-bold text-nova-text" data-id="element-76">
            ¿Cuál Plan Es Para Ti?
          </h2>
          <div className="w-16 h-[3px] bg-nova-accent mx-auto mt-4" data-id="element-77" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="overflow-x-auto" data-id="element-78">
          <table className="w-full min-w-[800px] border-collapse" data-id="element-79">
            <thead data-id="element-80">
              <tr data-id="element-81">
                <th className="p-4 text-left text-nova-accent font-semibold border-b border-nova-card" data-id="element-82">
                  CARACTERÍSTICA
                </th>
                <th className="p-4 text-center text-nova-accent font-semibold border-b border-nova-card" data-id="element-83">
                  LANDING
                </th>
                <th className="p-4 text-center text-nova-accent font-semibold border-b border-nova-card" data-id="element-84">
                  NEGOCIO
                </th>
                <th className="p-4 text-center text-nova-accent font-semibold border-b border-nova-card" data-id="element-85">
                  PLUS
                </th>
              </tr>
            </thead>
            <tbody data-id="element-86">
              {features.map((feature, index) => <tr key={index} className={index % 2 === 0 ? 'bg-nova-card/50' : 'bg-transparent'} data-id="element-87">
                  <td className="p-4 text-nova-text-muted text-sm border-b border-nova-card/50" data-id="element-88">
                    {feature.name}
                  </td>
                  <td className="p-4 text-center border-b border-nova-card/50" data-id="element-89">
                    {renderValue(feature.landing)}
                  </td>
                  <td className="p-4 text-center border-b border-nova-card/50" data-id="element-90">
                    {renderValue(feature.negocio)}
                  </td>
                  <td className="p-4 text-center border-b border-nova-card/50" data-id="element-91">
                    {renderValue(feature.plus)}
                  </td>
                </tr>)}
              <tr className="bg-nova-card" data-id="element-92">
                <td className="p-4 font-bold text-nova-text" data-id="element-93">PRECIO</td>
                <td className="p-4 text-center font-bold text-nova-accent" data-id="element-94">
                  $597.000
                </td>
                <td className="p-4 text-center font-bold text-nova-accent" data-id="element-95">
                  $897.000
                </td>
                <td className="p-4 text-center font-bold text-nova-accent" data-id="element-96">
                  $1.297.000
                </td>
              </tr>
            </tbody>
          </table>
        </motion.div>
      </div>
    </section>;
}